export const TOKEN_KEY = "token";
export const REFRESH_TOKEN_KEY = "refreshToken";
export const ADDITIONAL_TAB_KEY = "additionalTabsVisible";
export const SELECTED_LINK = "selectedLink";
export const DELIVERABLE_CREATE_KEY = "DELIVERABLE_CREATE";
export const COA_CREATE_KEY = "COA_CREATE";
export const TEMPLATE_CREATE_KEY = "RULE_ENGINE_TEMPLATE_CREATE";
export const RULE_ENGINE_TEMPLATE_UPLOAD_KEY = "RULE_ENGINE_TEMPLATE_UPLOAD";
export const RULE_ENGINE_TEMPLATE_EXPORT_KEY = "RULE_ENGINE_TEMPLATE_EXPORT";
export const DELIVERABLE_VIEW_KEY = 'DELIVERABLE_VIEW'
export const TENANT_NEMENIC_KEY = "tenantNemonic";